<script setup>
import { capitalize } from 'lodash'
import ButtonStateColorsForm from '@/components/customize/ButtonStateColorsForm.vue'

defineProps({
  type: {
    type: String,
    default: 'primary'
  }
})
</script>

<template>
  <div>
    <h6>{{ capitalize(type) }} Button</h6>
    <div class="row mt-4">
      <div class="col">
        <ButtonStateColorsForm :type="type" state="active" />
      </div>
      <div class="col">
        <ButtonStateColorsForm :type="type" state="hover" />
      </div>
      <div class="col">
        <ButtonStateColorsForm :type="type" state="disabled" />
      </div>
    </div>
  </div>
</template>
